export default function AdminNotices() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">AdminNotices</h1>
      <div className="card">
        <p>Content for AdminNotices...</p>
      </div>
    </div>
  );
}
